import api from "../services/api";

const path = "motivoCancelamento";

export const getCancellations = async () => {
  return await api.get(`${path}/todos`);
};

export const findCancellation = async ({ id }) => {
  return await api.get(`${path}/${id}`);
};

export const editCancellation = async ({ id, body }) => {
  return await api.put(`${path}/${id}`, body);
};

export const createCancellation = async ({ body }) => {
  return await api.post(`${path}`, body);
};

export const deleteCancellation = async ({ id }) => {
  return await api.delete(`${path}/${id}`);
};
